// extracted by mini-css-extract-plugin
export default {"Header":"shonqUwZ"};
    if(module.hot) {
      // 1776432165279
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  